import styled, { css } from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  grey1,
  grey3,
  grey4,
  grey5,
  grey6,
  purple5,
} from 'approot/shared/styles/colours.style';
import {
  hideNumberStepper,
  NumberInputStyled,
} from 'approot/shared/styles/inputs.style';
import {
  FlexCentreAlign,
  flexCentreAlignCss,
  FlexRightAlign,
  FlexSpaceBetween,
} from 'approot/shared/styles/flex.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import {
  spacing12,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { fontWeightBold } from 'approot/shared/styles/typography.style';
import { INPUT_WIDTH_SMALL, equationFieldCss } from './equation-response.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

type EquationResponseProps = {
  $vertical?: boolean;
};

export const EquationResponseForm = styled.form<EquationResponseProps>`
  ${flexCentreAlignCss}

  border: 1px solid ${grey4};
  border-radius: ${rem(borderRadius8)};
  max-width: ${rem(280)};
  background-color: ${grey1};
  padding: ${rem(spacing24)};
  margin: 0 auto;
  flex-direction: column;

  ${mediaUp.sm<EquationResponseProps>`
    ${({ $vertical }) =>
      !$vertical &&
      `
      flex-direction: row; 
      max-width: ${rem(640)};
    `}
  `}
`;

export const EquationResponseInput = styled(NumberInputStyled).attrs({
  min: 0,
  max: 999,
})`
  ${() => useActivityBuilderFontStyles()}
  ${equationFieldCss}

  border: none;
  border-bottom: 4px solid ${grey5};
  border-radius: 0;
  width: 100%;
  text-align: center;

  ${mediaUp.md`
    width: ${rem(INPUT_WIDTH_SMALL)};
  `}

  &:hover:not(:focus) {
    border: none;
    border-bottom: 4px solid ${grey5};
    box-shadow: 0 0 0 1px ${purple5};
  }

  &:focus {
    border-bottom: 4px solid ${grey1};
    border-radius: ${rem(borderRadius8)};
  }

  ${hideNumberStepper}
`;

export const EquationResponseInputVertical = styled(EquationResponseInput)`
  ${equationFieldCss}
  width: 100%;
  text-align: right;
  margin-bottom: ${rem(2)};
  border: none;

  &:hover:not(:focus) {
    border: none;
  }

  &:focus {
    border: none;
  }
`;

const answerCss = css`
  ${() => useActivityBuilderFontStyles()}

  width: 100%;
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  background-color: ${grey3};
  color: ${grey6};
  font-weight: ${fontWeightBold};
`;

export const EquationResponseAnswer = styled(FlexCentreAlign)`
  ${answerCss}
  ${equationFieldCss}

  ${mediaUp.lg`
    width: ${rem(INPUT_WIDTH_SMALL)};
  `}
`;

export const EquationResponseAnswerVertical = styled(FlexRightAlign)`
  ${answerCss}
  ${equationFieldCss}
  padding: ${rem(spacing16)};
`;

export const EquationResponseOperator = styled.div`
  ${() => useActivityBuilderFontStyles()}
  width: ${rem(31)};
  text-align: center;
  margin: 0 ${rem(spacing12)};
`;

export const EquationResponseOperatorWrapper = styled(FlexSpaceBetween)`
  width: 100%;
`;
